import { http } from '@/api/client/httpClient';
import type { SpreadHistoricalDto, SpreadHistoricalInput, SpreadLiveSnapshotDto } from '@/api/types/spreadMonitoring';

const BASE = '/api/app/spread-monitoring';

export const spreadMonitoringApi = {
  getLiveSnapshot: () => http.get<SpreadLiveSnapshotDto>(`${BASE}/live-snapshot`).then((r) => r.data),
  getHistorical: (input: SpreadHistoricalInput) =>
    http.get<SpreadHistoricalDto>(`${BASE}/historical-analysis`, { params: input }).then((r) => r.data),
};
